import Swal, { SweetAlertOptions } from "sweetalert2";

const SweetAlertService = {
  success(title, message) {
    return Swal.fire({
      icon: "success",
      title: title,
      text: message
    });
  },
  error(title, message) {
    return Swal.fire({
      icon: "error",
      title: title,
      text: message
    });
  },
  info(title, message) {
    return Swal.fire({
      icon: "info",
      title: title,
      text: message
    });
  },
  warning(title, message) {
    return Swal.fire({
      icon: "warning",
      title: title,
      text: message
    });
  },
  question(options) {
    return Swal.fire({
      icon: "question",
      title: options.title,
      text: options.text,
      showCancelButton: true,
      reverseButtons: false,
      cancelButtonText: options.cancelButtonText,
      confirmButtonText: options.confirmButtonText,
      confirmButtonColor: options.confirmButtonColor
    });
  },
  fire(options) {
    return Swal.fire(options);
  },
  test() {
    Swal.fire({
      title: "Submit your Github username",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Look up",
      showLoaderOnConfirm: true,
      preConfirm: login => {
        return fetch(`//api.github.com/users/${login}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .catch(error => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(result => {
      if (result.value) {
        Swal.fire({
          title: `${result.value.login}'s avatar`,
          imageUrl: result.value.avatar_url
        });
      }
    });
  }
};

export default SweetAlertService;



// WEBPACK FOOTER //
// ./src/service/SweetAlertService.js